export default "__VITE_ASSET__DezeZt0y__"